import React, { useEffect, useState } from "react";
import { Modal, ModalOverlay, ModalContent, ModalBody } from "@chakra-ui/modal";
import InputField from "components/fields/InputField";
import Upload from "views/admin/profile/components/Upload";
import { toast } from "react-toastify";
import AdminDataService from "../../services/admin.service";
import FileSaver from "file-saver";
import { Select, useEditable } from "@chakra-ui/react";
import axios from "axios";
import Loading from "components/loading/Loading";

const EditRestaurant = ({ isOpen, onOpen, onClose, getRestauRants, currData }) => {
  const [restaurantName, setRestaurantName] = useState("");
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [adminData, setAdminData] = useState([]);
  const [adminId, setAdminId] = useState("");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  
  useEffect(()=> {
    if(currData){
      getAdminData();
      setRestaurantName(currData.restaurant_name);
      setProductName(currData.drinks);
      setProductDescription(currData.drink_description);
      setAdminId(currData.adminId);
      setImages(currData.images);
    }
  },[isOpen])

  useEffect(()=> {
    if(!isOpen){
      setRestaurantName("");
      setProductName("");
      setProductDescription("");
      setAdminId("");
      setImages([]);
    }
  },[onClose])
  const getAdminData = () => {
    AdminDataService.getAdmins().then((res) => {
      if (res.data && res.data.status === "200") {
        setAdminData(res.data.data);
      }
    });
  }

  const handleImageUpload = (files) => {
    setImages(files);
  };


  const handleUpdate = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("restaurant_name", restaurantName);
    formData.append("drinks", productName);
    formData.append("drink_description", productDescription);
    formData.append("adminId", adminId);
    formData.append("id", currData._id);
      for (let i = 0; i < images.length; i++) {
        formData.append("images", images[i]);
      }
    const res = await axios.put(
      `${process.env.REACT_APP_HTTPCOMMON}/admin/update-restaurant`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "auth": `${localStorage.getItem("auth")}`,
        },
        withCredentials: true,
      }
    );
    if (res.data && res.data.status === "200") {
      toast.success("Restaurant updated successfully!");
      setLoading(false);
      setProductName("");
      setProductDescription("");
      setRestaurantName("");
      getRestauRants();
      onClose();
    } else {
      toast.error("Something went wrong! Please try again later.");
      setLoading(false);
    }
    try {
    } catch (err) {
      toast.error("Something went wrong! Please try again later.");
      setLoading(false);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} className="!z-[1010]">
        <ModalOverlay className="bg-[#000] !opacity-30" />
        <ModalContent className="!z-[1002] !m-auto w-full md:top-[12vh]">
          <ModalBody>
          {loading ? (
              <Loading message={`Updating restaurant`} />
            ) : (
            <div className="!z-[1004] mx-auto mt-48 flex max-w-[850px] flex-col rounded-md bg-white px-[30px] pt-[35px] pb-[40px] dark:!bg-navy-700 md:mt-5">
              <h1 className="mb-[20px] text-2xl font-bold">Update Restaurant</h1>
              <div className="mb-[5px] flex w-full">
                <div className="w-full p-2">
                  <InputField
                    label="Restaurant Name"
                    placeholder="@restaurant_name"
                    type="text"
                    value={restaurantName}
                    onChange={(e) => setRestaurantName(e.target.value)}
                  />
                </div>
                <div className="w-full p-2">
                  <InputField
                    label="Product"
                    placeholder="@product"
                    type="text"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-[5px] w-full">
                <div className="w-full p-2">
                  <InputField
                    label="Product Description"
                    placeholder="@product_description"
                    type="textarea"
                    rows="3"
                    value={productDescription}
                    onChange={(e) => setProductDescription(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-[5px] w-full">
                <div className="w-full p-2">
                  <label
                    for="countries"
                    class="mb-2 block text-sm font-semibold text-navy-700 ml-3 dark:text-white"
                  >
                    Select Owner/Manager
                  </label>
                  <select
                    value={adminId}
                    onChange={(e) => setAdminId(e.target.value)}
                    id="countries"
                    class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                  <option value={""} selected disabled>Choose owner</option>
                    {
                      adminData.map((admin, index) => (
                        <option key={index} value={admin._id}>{admin.first_name} {admin.last_name}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className="mb-[20px] w-full">
                <div className="w-full p-2">
                  <p className="ml-3 pb-1 text-sm font-semibold text-navy-700">
                    Restaurant Picture
                  </p>
                  <Upload onChange={handleImageUpload} images={currData.images} />
                </div>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={onClose}
                  className="linear rounded-xl border-2 border-red-500 px-5 py-3 text-base font-medium text-red-500 transition duration-200 hover:bg-red-600/5 active:bg-red-700/5 dark:border-red-400 dark:bg-red-400/10 dark:text-white dark:hover:bg-red-300/10 dark:active:bg-red-200/10"
                >
                  Close
                </button>
                <button
                  onClick={handleUpdate}
                  className="linear rounded-xl bg-gray-100 px-5 py-3 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                >
                  Update Restaurant
                </button>
              </div>
            </div>
            )
          }
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default EditRestaurant;
